import { useContextStore } from "@/stores/context";
import { transformText } from "./textUtils";
import translationsFile from "@/assets/files/translations";

export function getAllTranslations() {
    return translationsFile;
}

export function translate(text = '', textTransform = '') {
    if(!text || text == '')
        return text;
    try {
        const translations = getAllTranslations();
        if(translations[text] === undefined || translations[text] === null || translations[text] === '')
            return transformText(text, textTransform);
        return translations[text][useContextStore.getLang] === undefined || translations[text][useContextStore.getLang] === null
                ? transformText(text, textTransform)
                : transformText(translations[text][useContextStore.getLang], textTransform);
    } catch (error) {
        return text;
    }
}